import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import { BackTitle } from '@meitu/saas-ui/es/title';
import { Editor } from '@meitu/saas-editor-core/es/index';
import { useLocaleStore } from '@/i18n/index';
import EffectWrap from './components/effect-wrap/effect-wrap';
import { ActiveDataProvider } from './hook';
import ImageBlur from './views/image-blur';
import ImageBorderRadioItem from './views/image-border-radio-item';
import ImageEffectList from './views/image-effect-list/image-effect-list';
import ImageGlowItem from './views/image-glow-item';
import ImageShadowItem from './views/image-shadow-item/image-shadow-item';
import ImageStrokeItem from './views/image-stroke-item';
import './index.less';

const ImageEffectPanel: React.FC<{
    setPanel: Function;
    funcStatTrack: Function;
    effectListClickStatTrack: Function;
    editor: Editor;
    theme: string;
    className?: string;
}> = ({ setPanel, funcStatTrack, effectListClickStatTrack, editor, theme, className }) => {
    const { $t } = useLocaleStore();
    const [blurEffectOpen, setBlurEffectOpen] = useState(false);
    const [baseEffectOpen, setBaseEffectOpen] = useState(true);

    useEffect(() => {
        editor.history.setRedoUndo(false);
        editor.disableBasicOperate({ move: true, resize: true, rotate: true, scale: true });
        return () => {
            editor.history.setRedoUndo(true);
            editor.enableBasicOperate({ move: true, resize: true, rotate: true, scale: true });
        };
    }, []);

    return (
        <div className={classNames('c-image-effect-panel', className)}>
            <Scrollbars style={{ width: '100%', height: '100%' }}>
                <div className="title">
                    <BackTitle
                        text={$t((v) => v.imageEffectPanel.title)}
                        handleBackClick={() => {
                            setPanel(null);
                        }}
                    />
                </div>

                <EffectWrap
                    title={$t((v) => v.imageEffectPanel.subTitle.baseTitle)}
                    iconName="BrightnessBold"
                    open={baseEffectOpen}
                    setOpen={() => {
                        setBaseEffectOpen(!baseEffectOpen);
                        setBlurEffectOpen(false);
                    }}
                >
                    <ActiveDataProvider editor={editor}>
                        <ImageEffectList
                            effectListClickStatTrack={effectListClickStatTrack}
                            funcStatTrack={funcStatTrack}
                            editor={editor}
                            theme={theme}
                        />
                        <ImageStrokeItem funcStatTrack={funcStatTrack} editor={editor} theme={theme} />
                        <ImageShadowItem funcStatTrack={funcStatTrack} editor={editor} />
                        <ImageGlowItem funcStatTrack={funcStatTrack} editor={editor} />
                        <ImageBorderRadioItem funcStatTrack={funcStatTrack} editor={editor} />
                    </ActiveDataProvider>
                </EffectWrap>

                <EffectWrap
                    title={$t((v) => v.imageEffectPanel.subTitle.blurTitle)}
                    iconName="Blur"
                    open={blurEffectOpen}
                    setOpen={() => {
                        setBlurEffectOpen(!blurEffectOpen);
                        setBaseEffectOpen(false);
                    }}
                >
                    <ImageBlur setPanel={setPanel} editor={editor} />
                </EffectWrap>
            </Scrollbars>
        </div>
    );
};

export default ImageEffectPanel;
